/**
 * GFM tablo bloklarını dar alanlarda yatay kaydırma gerektirmeyen madde listesine çevirir.
 */

function parseTableRow(line: string): string[] {
  const m = line.trim().match(/^\|(.+)\|$/);
  if (!m) return [];
  return m[1].split("|").map((c) => c.trim());
}

function isSeparatorRow(line: string): boolean {
  const cells = parseTableRow(line);
  if (cells.length < 2) return false;
  return cells.every((c) => /^:?-{3,}:?$/.test(c.trim()));
}

function looksLikeTableHeaderWithSeparator(lines: string[], i: number): boolean {
  if (i + 1 >= lines.length) return false;
  const header = parseTableRow(lines[i] ?? "");
  if (header.length < 2) return false;
  return isSeparatorRow(lines[i + 1] ?? "");
}

function splitCellIntoLines(cell: string): string[] {
  const t = cell.replace(/<br\s*\/?>/gi, "\n");
  return t
    .split(/\n+/)
    .map((s) => s.trim())
    .filter(Boolean);
}

function formatTableAsList(header: string[][], rows: string[][]): string[] {
  const out: string[] = [];
  const h = header[0];
  if (h && h.length >= 2) {
    const left = h[0] ?? "";
    const right = h.slice(1).join(" — ");
    out.push(`**${left.replace(/\*\*/g, "").trim()}** — ${right}`);
    out.push("");
  }
  for (const row of rows) {
    if (!row.length) continue;
    const left = row[0] ?? "";
    const right = row.length > 1 ? row.slice(1).join(" | ") : "";
    if (row.length >= 2) {
      out.push(`- ${left}`);
      const pieces = splitCellIntoLines(right);
      for (const p of pieces) {
        if (/^[-*+]\s+/.test(p)) {
          out.push(`  ${p}`);
        } else {
          out.push(`  - ${p}`);
        }
      }
    } else {
      out.push(`- ${left}`);
    }
    out.push("");
  }
  return out;
}

export function convertGfmTablesToLists(markdown: string): string {
  const lines = markdown.split("\n");
  const out: string[] = [];
  let i = 0;
  while (i < lines.length) {
    if (looksLikeTableHeaderWithSeparator(lines, i)) {
      const headerCells = [parseTableRow(lines[i] ?? "")];
      i += 2;
      const rows: string[][] = [];
      while (i < lines.length) {
        const line = lines[i] ?? "";
        const trimmed = line.trim();
        if (!trimmed.startsWith("|") || !trimmed.includes("|")) break;
        if (isSeparatorRow(line)) {
          i += 1;
          continue;
        }
        const cells = parseTableRow(line);
        if (cells.length === 0) break;
        rows.push(cells);
        i += 1;
      }
      out.push(...formatTableAsList(headerCells, rows));
      continue;
    }
    out.push(lines[i] ?? "");
    i += 1;
  }
  return out.join("\n");
}
